export default __webpack_public_path__ + "static/media/SN3-2.d147dd3f.jpg";